import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { priceFormat } from '../../../../util';
import { selectPreviousRefunds, selectError, selectLoading } from '../../../../selectors/previousRefunds';
import { getPreviousRefunds } from '../../../../actions/tools/PreviousRefundsActions';
import { showExpressError } from '../../../../util/errorPopupUtil';
import * as colors from '../../../common/colorConstants';
import useInitialMount from '../../../../customHooks/useInitialMount';
import { ResultsColumn, ResultsColumnHeader, Row, HeaderRow, SubTitleText, Spreadsheet } from '../DTInfoWidget.styles';
import { SpinnerWrapper, Spinner } from '../../DecisionTree.styles';

const DTPreviousRefundsWidget = () => {
  const dispatch = useDispatch();
  const previousRefunds = useSelector(selectPreviousRefunds);
  const error = useSelector(selectError);
  const isLoading = useSelector(selectLoading);
  const isInitialMount = useInitialMount();

  useEffect(() => {
    dispatch(getPreviousRefunds());
  }, [dispatch]);

  if (error) {
    showExpressError(error, error.message);
  }

  // since we don't know what node will use this widget, there is no option to reset previousRefunds store before next call
  // firstRender condition prevents annoying blinking of previous results before next request
  // this way we always display loading before any results from the API delivered
  if (isInitialMount || isLoading) {
    return (
      <SpinnerWrapper>
        <Spinner color={colors.purple1} />
      </SpinnerWrapper>
    );
  }

  if (previousRefunds.length) {
    return (
      <Spreadsheet className="fs-block">
        <SubTitleText>PREVIOUS REFUNDS</SubTitleText>
        <HeaderRow>
          <ResultsColumnHeader>Date of refund</ResultsColumnHeader>
          <ResultsColumnHeader>Amount refunded</ResultsColumnHeader>
        </HeaderRow>
        {previousRefunds.map((item) => (
          <Row key={JSON.stringify(item)} className="fs-block">
            <ResultsColumn>{item.dateOfRefund}</ResultsColumn>
            <ResultsColumn>{priceFormat(item.amount, item.currency)}</ResultsColumn>
          </Row>
        ))}
      </Spreadsheet>
    );
  }

  return (
    <Spreadsheet className="fs-block">
      <SubTitleText>PREVIOUS REFUNDS</SubTitleText>
      <SubTitleText>No previous refunds found</SubTitleText>
    </Spreadsheet>
  );
};

export default DTPreviousRefundsWidget;
